import { resolveFlexibleContentCard } from '../flexible-content-card/resolveFlexibleContentCard';
import type { FrontendWidget } from '../types';
import { FlexibleCarouselComponent } from './FlexibleCarouselComponent';
import type { FlexibleCarouselConfig, FlexibleCarouselResolved } from './types';

export const flexibleCarouselWidget: FrontendWidget<
  FlexibleCarouselConfig,
  FlexibleCarouselResolved
> = {
  componentType: 'widgets.flexible-carousel',
  displayName: 'Flexible Carousel',
  // No `background` key — an empty background must stay empty.
  defaultValues: {
    columns: '3',
    iconSize: 'medium',
    cardPadding: 'small',
    showInheritedPhoneCta: false,
    cards: [],
  },
  ComponentA: FlexibleCarouselComponent,
  resolveSync: (config) => ({
    columns: config.columns ?? '3',
    background: config.background ?? null,
    iconSize: config.iconSize ?? 'medium',
    cardPadding: config.cardPadding ?? 'small',
    // Already resolved server-side by PhoneResolutionService — pass through.
    // The pair is kept intact here and gated at render time by `showInheritedPhoneCta`, so
    // the resolved block still reports what the chain produced.
    phone: config.phone,
    matelsoPhoneLabel: config.matelsoPhoneLabel,
    showInheritedPhoneCta: config.showInheritedPhoneCta ?? false,
    cards: (config.cards ?? []).map(resolveFlexibleContentCard),
  }),
};
